<template>
    <div class="container">
        <div class="flex-wrapper">
            <div>
                <img src="https://xperienceeducation-assets.s3.amazonaws.com/home/ipad.jpeg" alt="Ipad Image">
            </div>
            <div class="right-text">
                <h1>Research-Based Framework</h1>
                <p>
                    <b>DEEP</b> is derived from Oliver's Framework for Online Instruction© - a framework that has been validated by national focus groups and subject matter experts. Since <b>DEEP</b> has been tested for reliability through national focus groups and item analysis, you can be confident in the results.
                </p>
                <p>
                    <b><i>DEEP provides a medium for all stakeholders to establish a common understanding online pedagogy.</i></b>
                </p>
                <p style="padding-top: 30px; font-weight: 600;">
                     Questions? Email today <a href="mailto:Wendy.Oliver@XperienceEducation.com">Wendy.Oliver@XperienceEducation.com</a> 
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    "name": "home-section-5",
    setup() {
        
    },
}
</script>

<style lang="scss" scoped>
@import '@/styles/shared.scss';

.container{
    margin-bottom: 100px;
}

.flex-wrapper{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    @media(min-width: $bp-tablet-portrait){
        flex-wrap: nowrap;
        margin-left: 5%; 
        margin-right: 5%; 
    }

}

.right-text{
    margin-left: 5%;
    h1{
        color: #662d91;
        font-size: 1.5rem;
        text-align: left;

    }

    p{
        text-align: left;
    }
}
</style>